/**
 * Country utility functions for OurNet
 * Handles flag emojis and country code mapping
 */

/**
 * Returns flag emoji for a country code
 * @param {string} countryCode - ISO country code ('PT', 'GB', etc.)
 * @returns {string} flag emoji
 */
export const getCountryFlag = (countryCode) => {
  const flags = {
    'PT': '🇵🇹',
    'GB': '🇬🇧',
  };
  return flags[countryCode] || '🌍';
};

/**
 * Derives country code from country name
 * @param {string} country - Country name (e.g., 'Portugal', 'England')
 * @returns {string} ISO country code
 */
export const getCountryCodeFromName = (country) => {
  if (!country) return 'PT'; // default
  const c = country.toLowerCase();
  if (c.includes('portugal')) return 'PT';
  if (c.includes('england') || c.includes('scotland') || c.includes('wales') ||
      c.includes('northern ireland') || c.includes('united kingdom') || c === 'gb') {
    return 'GB';
  }
  return 'PT';
};

/**
 * Get full country name for display
 * @param {string} countryCode - ISO country code
 * @returns {string} Full country name
 */
export const getCountryName = (countryCode) => {
  const names = {
    'PT': 'Portugal',
    'GB': 'United Kingdom',
  };
  return names[countryCode] || countryCode;
};
